/**
 * Chatwoot widget config callable
 *
 * Loads `baseUrl` and `websiteToken` from `getChatwootConfig` for the onboarding product
 * without embedding secrets in the frontend bundle.
 */

import { ChatwootWidgetRuntimeConfig, GetChatwootConfigRequest, GetChatwootConfigResponse } from '@physiofit-digital/physiofit_types';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../../firebaseConfig';
import { CHATWOOT_WEB_APP_ONBOARDING_PRODUCT } from './chatwootProduct';
import { parseGetChatwootConfigResponse } from './parseGetChatwootConfigResponse';

function maskWebsiteToken(token: string): string {
  if (token.length <= 8) return '***';
  return `${token.slice(0, 4)}…${token.slice(-4)}`;
}

/**
 * Calls `getChatwootConfig` for the onboarding Chatwoot product.
 *
 * @return {Promise<Object | null>} Parsed runtime config or null on error.
 */
export async function fetchChatwootWidgetRuntimeConfig(): Promise<ChatwootWidgetRuntimeConfig | null> {
  const call = httpsCallable<GetChatwootConfigRequest, GetChatwootConfigResponse>(functions, 'getChatwootConfig');

  try {
    const res = await call({ product: CHATWOOT_WEB_APP_ONBOARDING_PRODUCT });
    const data = res.data as Record<string, unknown>;
    const parsed = parseGetChatwootConfigResponse(data);
    if (!parsed) {
      console.error('[Chatwoot onboarding] getChatwootConfig missing baseUrl/baseURL or websiteToken', data);
      return null;
    }
    console.info('[Chatwoot onboarding] getChatwootConfig resolved', {
      baseUrl: parsed.baseUrl,
      product: parsed.product,
      inboxId: parsed.inboxId,
      websiteTokenMasked: maskWebsiteToken(parsed.websiteToken),
    });
    return parsed;
  } catch (e) {
    console.error('[Chatwoot onboarding] getChatwootConfig error:', e);
    return null;
  }
}
